import BaseService from "./BaseService";
import {
  ActivityCategoryRequest,
  ActivityCategoryResponse,
  ActivityCategoriesResponse
} from "./mappers/ActivityCategoryMapper";

class ActivityCategoryService extends BaseService {
  constructor() {
    super();
  }

  createActivityCategory(data) {
    return this.post(`activity-categories/`, ActivityCategoryRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityCategoryResponse(data));
  }

  createCompanyActivityCategory(id, data) {
    return this.post(`companies/${id}/activity-categories/`, ActivityCategoryRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityCategoryResponse(data));
  }

  getActivityCategoriesByCompany(id) {
    return this.get(`companies/${id}/activity-categories/`)
      .then((response) => response.data)
      .then((data) => ActivityCategoriesResponse(data));
  }

  getActivityCategoriesByCompanyIncludingSystem(id) {
    return this.get(`companies/${id}/activity-categories/all/`)
      .then((response) => response.data)
      .then((data) => ActivityCategoriesResponse(data));
  }

  getActivityCategoriesBySystem() {
    return this.get(`system/activity-categories/`)
      .then((response) => response.data)
      .then((data) => ActivityCategoriesResponse(data));
  }

  getActivityCategory(id) {
    return this.get(`activity-categories/${id}/`)
      .then((response) => response.data)
      .then((data) => ActivityCategoryResponse(data));
  }

  getActivityCategories() {
    return this.get(`activity-categories/`)
      .then((response) => response.data)
      .then((data) => ActivityCategoriesResponse(data));
  }

  updateActivityCategory(id, data) {
    return this.patch(`activity-categories/${id}/`, ActivityCategoryRequest(data))
      .then((response) => response.data)
      .then((data) => ActivityCategoryResponse(data));
  }

  deleteActivityCategory(id) {
    return this.delete(`activity-categories/${id}/`);
  }
}

export default new ActivityCategoryService();
